const Ada = (n) => ({ ada: n });
const igen = (n) => [...new Array(n)].map((_, i) => i);
const gates = [
    GetHorsesInfo(14),
    GetHorsesInfo(13, 14),
    GetHorsesInfo(13, 27),
    GetHorsesInfo(13, 40)
];
function GetHorsesInfo(n, x = 0) {
    return igen(n).map((i) => ({
        name: `EquinePioneerHorse${(1 + i + x).toString().padStart(5, '0')}`,
        stable: `Stable ${1 + i + x}`,
        jockey: 'Jockey name',
        guild: 'Guild name'
    }));
}
function GetPrize(fee, prizePool) {
    var _a, _b;
    return Object.assign(Object.assign({}, prizePool), { ada: ((_a = prizePool.ada) !== null && _a !== void 0 ? _a : 0) + fee * ((_b = prizePool.percent) !== null && _b !== void 0 ? _b : 0) });
}
function GetRaceResults(entryFee, prizePool, gates) {
    return gates.map((instanceGate) => {
        const n = instanceGate.length;
        const places = igen(n).sort(() => 0.5 - Math.random());
        let t = 285 + 25 * (0.5 - Math.random());
        return places.map((gate, place) => {
            var _a, _b;
            t += (1 + 0.2 * place) * Math.random();
            return Object.assign(Object.assign({}, instanceGate[gate]), { time: t, gate,
                place, prize: GetPrize(n * ((_a = entryFee === null || entryFee === void 0 ? void 0 : entryFee.ada) !== null && _a !== void 0 ? _a : 0), (_b = prizePool[place]) !== null && _b !== void 0 ? _b : {}), racingPoints: Math.round(((15 - place) * (15 - place)) / 15) });
        });
    });
}
const track1 = {
    name: 'Track 1',
    surface: 'dirt',
    rating: 'soft',
    distance: 4000,
    fieldSize: 10,
    location: 'City 1, Country 1',
    curvature: 'Slow',
    turns: 'Left'
};
const track2 = {
    name: 'Track 2',
    surface: 'synthetic',
    rating: 'mediums',
    distance: 1200,
    fieldSize: 12,
    location: 'City 2, Country 2',
    curvature: 'Slow',
    turns: 'Left'
};
const weather = {
    rain: 0,
    wind: 0,
    windDirection: '',
    description: '',
    temperature: 0,
    altitude: 0,
    humidity: 0
};
const weather2 = {
    rain: 0,
    wind: 15,
    windDirection: 'North West',
    description: 'Clear Sky',
    temperature: 22,
    altitude: 10,
    humidity: 3
};
const prizePool = [
    { percent: 40 },
    { percent: 20 },
    { percent: 15 },
    { percent: 10 },
    { percent: 8 },
    { percent: 7 }
];
const race1 = {
    id: '01',
    name: 'Race 1',
    date: new Date('2022-12-16T08:41-04:00'),
    currentEntries: 53,
    eventInfo: 'Recurring Friday Race',
    entryFee: Ada(20),
    trackDetails: track1,
    weather,
    season: 1,
    location: 'City 1, Country 1',
    distance: 4000,
    prizePool,
    scratchFee: { percent: 2 },
    canScratch: true,
    gates,
    results: GetRaceResults(Ada(20), prizePool, gates),
    status: 'completed'
};
const race2 = {
    id: '02',
    name: 'Race 2',
    date: new Date('2023-04-16T18:00-04:00'),
    trackDetails: track2,
    season: 1,
    location: 'City 2, Country 2',
    distance: 2000,
    requirements: { class: 2 },
    currentEntries: 10,
    eventInfo: 'Single Free Race',
    entryFee: Ada(0),
    prizePool: [
        { percent: 40, ada: 25, SnowmanJockeySkin: 1 },
        { percent: 20, ada: 10 },
        { percent: 15, ada: 5 },
        { percent: 10 },
        { percent: 8 },
        { percent: 7 }
    ],
    maxEntries: 16,
    scratchFee: Ada(1),
    canScratch: true,
    weather,
    status: 'announced'
};
const raceList = [race1, race2];
const raceResult = {
    name: 'Quicksilver',
    stable: 'Name of Stable',
    jockey: 'Default',
    guild: 'Test Guild',
    place: 2,
    prize: { ada: 37.5 },
    time: 120.3
};
const delay = (val) => {
    const errorRate = 0.02;
    const delayMs = 200 + 500 * (Math.random() + Math.random() + Math.random());
    return new Promise((resolve, reject) => {
        if (Math.random() < errorRate) {
            setTimeout(() => reject('Random API Error'), delayMs);
        }
        else {
            setTimeout(() => resolve(val), delayMs);
        }
    });
};
const races = {
    race1,
    race2
};
export const Mock = {
    getRaces: (options) => delay(raceList),
    getRace: (id) => delay(races[id]),
    completeRace: (asset, id) => delay(raceResult),
    adminCreateRace: (info) => delay('raceIdString'),
    adminUpdateRace: (info) => delay('raceIdString'),
    delayTrue: (...params) => delay(true)
};
